interface Props {
  className?: string;
}

export default function BankAccount({ className }: Props) {
  return (
    <svg
      className={`dark:text-text-dark text-text-light ${className}`}
      fill='none'
      height='12'
      viewBox='0 0 11 12'
      width='11'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        clipRule='evenodd'
        d='M3.48389 1.35938H5.24798V11.9705H3.48389V1.35938Z'
        fill='currentColor'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M0.830566 1.35938H2.59466V11.9705H0.830566V1.35938Z'
        fill='currentColor'
        fillRule='evenodd'
      />
      <path
        clipRule='evenodd'
        d='M6.57861 0.03125H10.9999V5.33679H6.57861V0.03125Z'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  );
}
